// extracted by mini-css-extract-plugin
export default {"hideTooltip":"a_-z","fadeIn":"b_-z","delay":"c_-z","recommendedSizeTooltip":"d_-z"};